// extracted by mini-css-extract-plugin
export default {"modalOverlay":"iD-z","modalContent":"jD-z","header":"kD-z","close":"lD-z"};